export default function createMenuItemFromResource(data) {
  if (!data) {
    return null;
  }

  return {
    icon: data.icon,
    id: data.id,
    isAllowedForAuthorized: data.is_allowed_for_authorized,
    isAllowedForGuest: data.is_allowed_for_guest,
    isBlank: data.is_blank,
    isEnabled: data.is_enabled,
    isInApp: data.is_in_app,
    name: data.name,
    translations: data.translations,
    url: data.url,
  };
}
